import { EMPTY_FIELD } from 'constants/emptyField';

import { Box } from 'shared/mui/Box';
import { Chip } from 'shared/mui/Chips';
import { FunctionField } from 'shared/react-admin/Fields';
import { RoleInfo } from 'types/embedded/role';

type RolesStatusesChipsFieldProps = {
  label?: string;
  record?: RoleInfo;
};

export const RolesStatusesChipsField: React.FC<RolesStatusesChipsFieldProps> = ({ label }) => (
  <FunctionField
    label={label}
    render={(record: RoleInfo) => {
      const statuses = record?.allowedStatusesEditingEnum;

      return statuses?.length ? (
        <Box sx={{ gap: '8px', display: 'flex', flexWrap: 'wrap' }}>
          {statuses.map(({ description }) => (
            <Chip key={description} label={description} />
          ))}
        </Box>
      ) : (
        EMPTY_FIELD
      );
    }}
  />
);
